// @ts-strict-ignore
import styled from 'styled-components';
import { useDispatch, useSelector } from 'src/store/store';
import i18n from 'src/utils/translate';
import { showModal } from 'src/modules/shared/modal/actions';
import { ModalType } from 'src/constants/modalTypes';
import { Section } from 'src/constants/footfall';
import { AttentionContainer } from 'src/modules/user/profile/components/shared/sharedStyles';
import { ProfileTab } from 'src/constants/types';
export default function NoPostsYetMessage() {
  const dispatch = useDispatch();
  const {
    profileUser,
    currentTab
  } = useSelector(({
    pages
  }) => pages.profile);
  const {
    isOwnProfile,
    username
  } = profileUser;
  const onWrite = e => {
    e.preventDefault();
    dispatch(showModal({
      modalType: ModalType.SelectCommunityToPost,
      modalProps: {
        section: Section.ProfilePosts
      }
    }));
  };
  return <NoPostsWrapper data-sentry-element="NoPostsWrapper" data-sentry-component="NoPostsYetMessage" data-sentry-source-file="noPostsMessage.tsx">
      <AttentionContainer data-testid="attention-container" data-sentry-element="AttentionContainer" data-sentry-source-file="noPostsMessage.tsx">
        {isOwnProfile ? <span>
            {i18n.t('Hi ')}{username}{', '}
            {i18n.t(`it looks like you haven't written anything yet. Get the ball rolling by`)}{' '}
            <a href="#" onClick={onWrite}>{i18n.t('introducing yourself!')}</a>
          </span> : <span>
            <b>{username}</b>
            {currentTab === ProfileTab.Posts ? i18n.t(' has not written a post yet. ') : i18n.t(' has not yet replied to any post. ')}
            {i18n.t('Please check back later or follow them to be notified when they do!')}
          </span>}
      </AttentionContainer>
    </NoPostsWrapper>;
}
const NoPostsWrapper = styled.div`
  @media (${({
  theme
}) => theme.underScreenMedium}) {
    padding: 0 12px;
  }
`;